(function () {
  'use strict';

  function initUmaPaymentReward(reward) {
    if (!reward || reward.dataset.umaPaymentInitialized === 'true') {
      return;
    }

    reward.dataset.umaPaymentInitialized = 'true';

    var sectionId = reward.getAttribute('data-section-id') || '';
    var discountPercent = Number(
      reward.getAttribute('data-discount-percent') || 5
    );

    if (!discountPercent || discountPercent < 1) {
      discountPercent = 5;
    }

    var section = null;

    if (sectionId) {
      section = document.getElementById(
        'ProductSection-' + sectionId
      );
    }

    if (!section) {
      section = reward.closest('[id^="ProductSection-"]');
    }

    if (!section) {
      section = reward.parentElement;
    }


    /* -----------------------------------------
       VARIANT DATA
       ----------------------------------------- */

    var variants = [];

    var variantsScript = reward.querySelector(
      '[data-uma-payment-variants]'
    );

    if (variantsScript) {
      try {
        variants = JSON.parse(
          variantsScript.textContent || '[]'
        );
      } catch (error) {
        variants = [];
      }
    }


    /* -----------------------------------------
       ELEMENTS
       ----------------------------------------- */

    var regularPriceElement = reward.querySelector(
      '[data-uma-payment-regular]'
    );

    var onlinePriceElement = reward.querySelector(
      '[data-uma-payment-online]'
    );

    var savingElement = reward.querySelector(
      '[data-uma-payment-saving]'
    );


    /* -----------------------------------------
       MONEY FORMAT
       ----------------------------------------- */

    function getCurrency() {
      if (
        window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active
      ) {
        return Shopify.currency.active;
      }

      return 'INR';
    }

    function formatMoney(cents) {
      cents = Number(cents || 0);

      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: getCurrency(),
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (error) {
        return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
      }
    }


    /* -----------------------------------------
       FIND VARIANT BY ID
       ----------------------------------------- */

    function findVariantById(id) {
      if (!id) {
        return null;
      }

      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) {
          return variants[i];
        }
      }

      return null;
    }


    /* -----------------------------------------
       CLEAN PACK SELECTED VARIANT
       ----------------------------------------- */

    function getCleanPackVariant() {
      if (!section) {
        return null;
      }

      var input = section.querySelector(
        '.uma-clean-pack-input:checked'
      );

      if (!input) {
        return null;
      }

      var variantId = input.getAttribute(
        'data-variant-id'
      );

      var variant = findVariantById(variantId);

      if (variant) {
        return variant;
      }

      var inputPrice = Number(
        input.getAttribute('data-variant-price') || 0
      );

      if (inputPrice > 0) {
        return {
          id: variantId || '',
          price: inputPrice
        };
      }

      return null;
    }


    /* -----------------------------------------
       PRODUCT SELECT VARIANT
       ----------------------------------------- */

    function getProductSelectVariant() {
      if (!section) {
        return null;
      }

      var productSelect = null;

      if (sectionId) {
        productSelect = section.querySelector(
          '#ProductSelect-' + sectionId
        );
      }

      if (!productSelect) {
        productSelect = section.querySelector(
          'select[name="id"]'
        );
      }

      if (!productSelect || !productSelect.value) {
        return null;
      }

      return findVariantById(
        productSelect.value
      );
    }


    /* -----------------------------------------
       CURRENT VARIANT
       ----------------------------------------- */

    function getCurrentVariant() {
      var cleanPackVariant = getCleanPackVariant();

      if (cleanPackVariant) {
        return cleanPackVariant;
      }

      var productSelectVariant =
        getProductSelectVariant();

      if (productSelectVariant) {
        return productSelectVariant;
      }

      return variants.length
        ? variants[0]
        : null;
    }


    /* -----------------------------------------
       CALCULATE PAYMENT REWARD

       Example:
       ₹153 × 5% = ₹7.65
       Round saving = ₹8

       ₹153 - ₹8 = ₹145
       ----------------------------------------- */

    function calculateReward(priceInCents) {
      var price = Number(priceInCents || 0);

      if (price <= 0) {
        return {
          regular: 0,
          saving: 0,
          online: 0
        };
      }

      var rawSavingCents =
        price * discountPercent / 100;

      /*
       * Convert calculated saving to rupees,
       * round to nearest whole rupee,
       * then convert back to paise.
       */
      var savingCents =
        Math.round(rawSavingCents / 100) * 100;

      var onlineCents =
        price - savingCents;

      if (onlineCents < 0) {
        onlineCents = 0;
      }

      return {
        regular: price,
        saving: savingCents,
        online: onlineCents
      };
    }


    /* -----------------------------------------
       UPDATE UI
       ----------------------------------------- */

    function renderVariant(variant) {
      if (
        !variant ||
        typeof variant.price === 'undefined'
      ) {
        return;
      }

      var result = calculateReward(
        variant.price
      );

      if (regularPriceElement) {
        regularPriceElement.textContent =
          formatMoney(result.regular);
      }

      if (onlinePriceElement) {
        onlinePriceElement.textContent =
          formatMoney(result.online);
      }

      if (savingElement) {
        savingElement.textContent =
          formatMoney(result.saving);
      }
    }


    /* -----------------------------------------
       NORMAL SYNC
       ----------------------------------------- */

    function syncReward() {
      var variant = getCurrentVariant();

      if (variant) {
        renderVariant(variant);
      }
    }


    /*
     * Some Shopify themes update the hidden
     * product selector slightly after the customer
     * clicks a visible pack.
     *
     * These short checks make sure the final
     * displayed price is always correct.
     */

    function scheduleSync() {
      syncReward();

      window.requestAnimationFrame(function () {
        syncReward();
      });

      window.setTimeout(
        syncReward,
        40
      );

      window.setTimeout(
        syncReward,
        120
      );

      window.setTimeout(
        syncReward,
        300
      );
    }


    /* -----------------------------------------
       PACK / VARIANT CHANGES
       ----------------------------------------- */

    if (section) {
      section.addEventListener(
        'change',
        function (event) {
          if (!event.target) {
            return;
          }

          if (
            event.target.matches(
              '.uma-clean-pack-input'
            ) ||
            event.target.matches(
              '.single-option-selector__radio'
            ) ||
            event.target.matches(
              '.single-option-selector'
            ) ||
            event.target.matches(
              '[data-single-option-selector]'
            ) ||
            event.target.matches(
              'select[name="id"]'
            )
          ) {
            scheduleSync();
          }
        }
      );


      /* ---------------------------------------
         CLEAN PACK CLICK

         Update immediately from clicked card.
         --------------------------------------- */

      section.addEventListener(
        'click',
        function (event) {
          if (
            !event.target ||
            !event.target.closest
          ) {
            return;
          }

          var card = event.target.closest(
            '.uma-clean-pack-card'
          );

          if (
            !card ||
            !section.contains(card)
          ) {
            return;
          }

          var variantId = card.getAttribute(
            'data-variant-id'
          );

          var variant = findVariantById(
            variantId
          );

          if (variant) {
            renderVariant(variant);
          } else {
            var cardPrice = Number(
              card.getAttribute(
                'data-variant-price'
              ) || 0
            );

            if (cardPrice > 0) {
              renderVariant({
                id: variantId || '',
                price: cardPrice
              });
            }
          }

          window.setTimeout(
            syncReward,
            70
          );

          window.setTimeout(
            syncReward,
            200
          );
        }
      );
    }


    /* -----------------------------------------
       SHOPIFY / THEME VARIANT EVENTS
       ----------------------------------------- */

    document.addEventListener(
      'variant:change',
      function (event) {
        var variant =
          event &&
          event.detail &&
          (
            event.detail.variant ||
            event.detail
          );

        if (
          variant &&
          typeof variant.price !== 'undefined'
        ) {
          renderVariant(variant);
        } else {
          scheduleSync();
        }
      }
    );


    document.addEventListener(
      'product:variant-change',
      function (event) {
        var variant =
          event &&
          event.detail &&
          (
            event.detail.variant ||
            event.detail
          );

        if (
          variant &&
          typeof variant.price !== 'undefined'
        ) {
          renderVariant(variant);
        } else {
          scheduleSync();
        }
      }
    );


    /* -----------------------------------------
       INITIAL STATE
       ----------------------------------------- */

    scheduleSync();

    window.setTimeout(
      scheduleSync,
      400
    );

    window.setTimeout(
      scheduleSync,
      1000
    );
  }


  /* =========================================
     INITIALISE ALL PAYMENT REWARD COMPONENTS
     ========================================= */

  function initAllUmaPaymentRewards() {
    var rewards = document.querySelectorAll(
      '[data-uma-payment-reward]'
    );

    rewards.forEach(function (reward) {
      initUmaPaymentReward(reward);
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllUmaPaymentRewards
    );
  } else {
    initAllUmaPaymentRewards();
  }


  window.addEventListener(
    'load',
    initAllUmaPaymentRewards
  );

})();